import styled from 'styled-components';

import { media } from '../../../styles/helpers';
import SectionTitle from '../../SectionTitle';

export const DiscountContentWrapper = styled('div')`
  width: 100%;
  padding: 30px 30px 10px;
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  pointer-events: auto;
  p {
    color: #ffffff;
    font-size: 20px;
    font-weight: 400;
    line-height: 32px;
    margin-bottom: 30px;
  }
  button {
    align-self: center;
  }
`;

export const AffSectionTitle = styled(SectionTitle)`
  h1 {
    text-align: left;
    color: #ffffff;
    font-size: 30px;
    font-weight: 700;
    line-height: 44px;
    text-transform: none;
    margin-bottom: 27px;
    width: 100%;
    max-width: 200px;

    ${media.mobile`
      font-size: 34px;
      max-width: 220px;
    `}
  }
`;

export default DiscountContentWrapper;
